import { render } from "./CashbackDetails.vue?vue&type=template&id=0ec6837c&scoped=true"
import script from "./CashbackDetails.vue?vue&type=script&lang=js"
export * from "./CashbackDetails.vue?vue&type=script&lang=js"

import "./CashbackDetails.vue?vue&type=style&index=0&id=0ec6837c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec6837c"]])

export default __exports__